import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "wpcm-radial-progress-bar" }
const _hoisted_3 = {
  key: 0,
  class: "circular"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "wpcm-amount-collected"
}
const _hoisted_7 = { class: "amount-return" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "wpcm-amount-needed"
}
const _hoisted_10 = { class: "amount-return" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      ($props.collected >= 0 && $props.needed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("input", {
              class: "knob",
              ref: "knob",
              "data-fgColor": "#d8281b",
              "data-bgColor": "#dddddd",
              "data-thickness": ".10",
              readonly: "",
              value: (($props.collected / $props.needed)*100).toFixed(1)
            }, null, 8 /* PROPS */, _hoisted_4),
            ($props.strings)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($props.strings.completed), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, $props.show_progress]
    ]),
    ($props.show_collection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("i", null, _toDisplayString($props.symbol), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString($setup.formatNumber($props.collected)), 1 /* TEXT */)
          ]),
          ($props.strings)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.strings.collection), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.show_collection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("i", null, _toDisplayString($props.symbol), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString($setup.formatNumber($props.needed)), 1 /* TEXT */)
          ]),
          ($props.strings)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($props.strings.target), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}